import { ContainedBtn } from '@components/Buttons';
import { Divider } from '@components/Common';
import { SignupNewsletterForm } from '@components/Forms';
import { navigateAppStore, Routes } from '@navigation';
import React, { FC, useState } from 'react';

interface Props {
  className?: string;
}

const PostSidebarDownloadAppSection: FC<Props> = ({ className }) => {
  const [success, setSuccess] = useState<boolean>(false);

  const handleDownloadClick = () => {
    navigateAppStore(() => {
      const element = document.getElementById('get-started-banner');
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <div className={className}>
      <div className="pb-8">
        <h6 className="mt-0 leading-6 mb-3 font-bold font-sans text-xl">Download the App</h6>
        <p className="text-ocean-blue font-medium">
          The CircleOf App gives families and friends the power to build on-demand communities of care. With CircleOf, asking for
          and offering help is seamless and stressless!
        </p>

        <ContainedBtn
          onClick={handleDownloadClick}
          className="mt-8"
          style={{
            fontSize: 16,
            fontWeight: 600,
            display: 'inline-flex',
          }}
        >
          Download the App
        </ContainedBtn>
      </div>

      <Divider />

      <div className="mt-8">
        <h6 className="mt-0 leading-6 mb-3 font-bold font-sans text-xl">Stay in Touch</h6>
        {!success && (
          <p className="text-ocean-blue font-medium">
            Hey caregivers, not ready to download the app, but want to stay in the loop? We send out a monthly newsletter and do
            not spam you.
          </p>
        )}

        <div className="flex flex-col">
          {!success ? (
            <>
              <SignupNewsletterForm
                onSuccess={setSuccess}
                containerClassName="border-neutral-gray border mt-8"
                buttonClassName="bg-accent-green"
              />
              <span className="text-sm font-medium text-ocean-blue mt-3">
                By signing up, you agree to our{' '}
                <a href={Routes.privacyPolicy.url} target="_blank" className="underline font-bold">
                  Privacy Policy
                </a>
              </span>
            </>
          ) : (
            <p className="text-sm font-medium text-ocean-blue mt-3">
              Thanks for signing up, and welcome to the CircleOf community! We care, together.
              <br />
              <br />
              Add <b>hello@circleof.com</b> to your address book to ensure you get our newsletters.{' '}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostSidebarDownloadAppSection;
